/* eslint-disable @bigbinary/neeto/use-neetoui-classes */
import { forwardRef, useEffect } from "react";

import { globalProps } from "neetocommons/initializers";
import PropTypes from "prop-types";

import ProfileButton from "./components/ProfileButton";
import { setAppTheme } from "./utils";

const FloatingActionMenu = forwardRef(
  (
    {
      profileInfoOverrides = {},
      topLinks = [],
      bottomLinks = [],
      showProductSwitcher = true,
      isThemeSwitcherEnabled = false,
      isOrganizationSwitcherEnabled = false,
      customContent,
      profilePopoverProps = {},
      isConsumer = false,
      enableSubscriptionUpgradeRequest = true,
      ...otherProps
    },
    ref
  ) => {
    useEffect(() => {
      isThemeSwitcherEnabled && setAppTheme();
    }, [isThemeSwitcherEnabled]);

    const isBigBinaryEmail =
      globalProps?.user?.email?.endsWith("@bigbinary.com");

    return (
      <div
        {...{ ref }}
        className="fixed start-0 bottom-4 z-[99999] rounded-e-[1.0625rem] border border-s-0 border-white bg-white"
        data-testid="floating-action-menu-container"
        {...otherProps}
      >
        <ProfileButton
          {...{
            bottomLinks,
            customContent,
            enableSubscriptionUpgradeRequest,
            isConsumer,
            isOrganizationSwitcherEnabled,
            isThemeSwitcherEnabled,
            profileInfoOverrides,
            profilePopoverProps,
            showProductSwitcher,
            topLinks,
          }}
          isOrganizationSwitcherEnabled={
            isBigBinaryEmail || isOrganizationSwitcherEnabled
          }
        />
      </div>
    );
  }
);

FloatingActionMenu.displayName = "FloatingActionMenu";

FloatingActionMenu.propTypes = {
  profileInfoOverrides: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    imageUrl: PropTypes.string,
  }),
  customContent: PropTypes.element,
  topLinks: PropTypes.arrayOf(
    PropTypes.shape({
      onClick: PropTypes.func,
      label: PropTypes.string,
      icon: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.func,
        PropTypes.object,
      ]),
    })
  ),
  bottomLinks: PropTypes.arrayOf(
    PropTypes.shape({
      onClick: PropTypes.func,
      label: PropTypes.string,
      icon: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.func,
        PropTypes.object,
      ]),
    })
  ),
  isConsumer: PropTypes.bool,
  showProductSwitcher: PropTypes.bool,
  isThemeSwitcherEnabled: PropTypes.bool,
  isOrganizationSwitcherEnabled: PropTypes.bool,
  enableSubscriptionUpgradeRequest: PropTypes.bool,
  profilePopoverProps: PropTypes.shape({
    preferredDateFormat: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      helpLinkProps: PropTypes.shape({
        label: PropTypes.string,
        href: PropTypes.string,
      }),
    }),
    preferredTimeFormat: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      helpLinkProps: PropTypes.shape({
        label: PropTypes.string,
        href: PropTypes.string,
      }),
    }),
    timeZone: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      helpLinkProps: PropTypes.shape({
        label: PropTypes.string,
        href: PropTypes.string,
      }),
    }),
  }),
};

export default FloatingActionMenu;
